<div class="products-table-row heads" *ngIf="!isMobile">
  <span *ngFor="let head of heads" [innerHTML]="head"></span>
  <span (click)="reorder.emit()">
    <i class="db-icon db-icon-ds-reorder-1"></i>
  </span>
</div>
  <ng-content></ng-content>
